var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"yhc-component yhc-fzc-black PrivateEndLabel endLabel",style:(_vm.endLabelStyle),on:{"click":_vm.tapEndLabel}},[(_vm.isBtnEndLabel)?_c('el-button',{attrs:{"type":_vm.endLabelType,"size":"mini"}},[_vm._v(" "+_vm._s(_vm.endLabel)+" ")]):_c('div',[_vm._v(_vm._s(_vm.endLabel))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }